import createList from '../../with-list';

import qs from 'querystring';

import endpoints from '../../../../config/endpoints';

const namespace = 'blogArticleImageList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BLOG.ARTICLE_IMAGES,
	perPage: 10,
	getRequestQuery
});

function getRequestQuery(page, getState) {
	const state = getState()[namespace];
	const query = qs.parse(location.search.slice(1));

	const limit = state.pagination.perPage;

	return {
		search: query.search,
		langs: query.langs && query.langs.split(','),
		offset: (page - 1) * limit,
		limit
	};
}

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-image/list/index.js